var updated = "11.10.2026";
var title = "Stefano Caronia";
var sections = {
    informations: {
        label: "Links",
        icon: "fa-link",
        content: {
            info: [
                {
                    label: "Role",
                    content: "Developer, Writer, Musician",
                    iconClass: "fas fa-user-tie"
                },
                {
                    label: "Focus",
                    content: "Game development, developer tools, AI experiments, and creative computing",
                    iconClass: "fas fa-crosshairs"
                },
                {
                    label: "Location",
                    content: "Italy",
                    iconClass: "fas fa-map-marker-alt"
                }
            ],
            links: [
                {
                    label: "stefano.caronia@gmail.com",
                    path: "mailto:stefano.caronia@gmail.com",
                    iconClass: "fas fa-envelope"
                },
                {
                    label: "github.com/stefanocaronia",
                    path: "https://github.com/stefanocaronia",
                    iconClass: "fab fa-github"
                },
                {
                    label: "linkedin.com/in/stefanocaronia",
                    path: "https://www.linkedin.com/in/stefanocaronia/",
                    iconClass: "fab fa-linkedin"
                },
                {
                    label: "steamcommunity.com/id/sshevek/",
                    path: "https://steamcommunity.com/id/sshevek/",
                    iconClass: "fab fa-steam"
                },
                {
                    label: "x.com/sshevek",
                    path: "https://x.com/sshevek",
                    iconClass: "fab fa-twitter"
                },
                {
                    label: "www.instagram.com/sshevek/",
                    path: "https://www.instagram.com/sshevek/",
                    iconClass: "fab fa-instagram"
                },
                {
                    label: "soundcloud.com/irprocess",
                    path: "https://soundcloud.com/irprocess",
                    iconClass: "fab fa-soundcloud"
                }
            ]
        }
    },
    about: {
        label: "About",
        icon: "fa-user",
        content: {
            text: "I'm a full-time video game programmer currently working on <a href=\"https://www.eraone.co.uk/\" target=\"_blank\">Era One</a>, a space RTS developed with a fantastic team at <a href=\"https://www.teamcomplex.co.uk/\" target=\"_blank\">Team Complex Ltd</a>. \
            <br>Outside work, I spend my time being a dad, playing guitar, experimenting with AI agents, and building games in assembly for the Commodore 64,about forty years after I first dreamed of doing it.",
            points: [
                {
                    label: "What I like building",
                    iconClass: "fas fa-cubes",
                    tags: [
                    "Gameplay and simulation systems",
                    "Developer tools",
                    "Small focused products"
                    ]
                },
                {
                    label: "Current direction",
                    iconClass: "fas fa-compass",
                    tags: [
                    "Game development",
                    "AI-assisted workflows",
                    "Simulation systems",
                    "Experimental computing"
                    ]
                },
                {
                    label: "Future plans",
                    iconClass: "fas fa-road",
                    tags: [
                    "Dedicating time to art again",
                    "Composing a piano album",
                    "Writing a book",
                    "Exploring electronics and Arduino",
                    "Woodworking",
                    "Designing board games",
                    "Running tabletop RPGs as a game master",
                    "Learning to draw",
                    "Learning 3D modeling",
                    "Learning pixel art"
                    ]
                }
            ]
        }
    },
    professional: {
        label: "Professional Work",
        icon: "fa-briefcase",
        content: {
            items: [
                {
                    label: "Era One",
                    path: "https://www.eraone.co.uk/",
                    descHtml: "Space real-time strategy game in development in Unity, featuring fleet control, logistics systems and large-scale battles",
                    iconClass: "fas fa-cubes",
                    status: "In progress",
                    extraLinks: [
                        {
                            label: "Team Complex Ltd",
                            path: "https://www.teamcomplex.co.uk/",
                            iconClass: "fas fa-users"
                        },
                        {
                            label: "Steam page",
                            path: "https://store.steampowered.com/app/2509200/ERA_ONE/",
                            iconClass: "fab fa-steam"
                        }
                    ]
                }
            ]
        }
    },
    projects: {
        label: "Personal Projects",
        icon: "fa-lightbulb",
        content: {
            code: [
                {
                    label: "J. Miller AI",
                    path: "https://jmillerai.org/",
                    desc: "AI-driven project in active development. Experimental autonomous AI agent with a network-based memory and routines for learning, creative thinking and dreaming. It progressively reads books, gathers experiences and maintains its own blog, running on a Raspberry Pi.",
                    iconClass: "fas fa-cubes",
					status: "In progress"
                },
                {
                    label: "Write Kit",
                    path: "https://github.com/stefanocaronia/writekit",
                    desc: "A writing toolkit that turns Markdown into books. Write in plain text files and generate PDF, ePub, HTML and Word documents with a single command.",
                    iconClass: "fas fa-cubes",
                    status: "In progress",
                    extraLinks: [
                        {
                            label: "npm",
                            path: "https://www.npmjs.com/package/writekit",
                            iconClass: "fab fa-npm"
                        }
                    ]
                },
                {
                    label: "RPG Engine",
                    path: "https://github.com/stefanocaronia/rpg-engine",
                    desc: "A tabletop RPG engine for AI game masters, available as a CLI and an MCP server. The model narrates and interprets the rules, while the tool remembers the campaign, computes and rolls the dice. Written in TypeScript, compatible with fifth edition (SRD 5.1).",
                    iconClass: "fas fa-cubes",
                    status: "In progress"
                },
                {
                    label: "Crew",
                    path: "https://github.com/stefanocaronia/claude-crew",
                    desc: "A Claude Code plugin that gives a project a standing team of expert colleagues: subagents with a profile, a character, a memory that lasts across sessions and their own todo list. They review the work at milestones, take on tasks in their field within binding permissions, and you can talk with them one-to-one or in meetings, right in the chat. One plugin, crew, brings both the skill and an in-app panel showing the team at work, available in 11 languages.",
                    iconClass: "fas fa-cubes",
                    status: "In progress",
                    extraLinks: [
                        {
                            label: "Plugin",
                            path: "https://github.com/stefanocaronia/claude-crew/tree/main/plugins/crew",
                            iconClass: "fab fa-github"
                        }
                    ]
                },
                {
                    label: "Dopamine Simulator",
                    path: "https://github.com/stefanocaronia/dopamine-simulator",
                    desc: "Interactive educational simulation of a dopamine synapse, comparing neurotypical and ADHD dynamics. Variables like sleep, caffeine, medication, exercise and substances can be tweaked to see how release, receptor binding and reuptake change. Plain HTML/CSS/JavaScript, no dependencies, available in 11 languages.",
                    iconClass: "fas fa-cubes",
                    status: "Completed",
                    extraLinks: [
                        {
                            label: "Live simulator",
                            path: "https://stefanocaronia.github.io/dopamine-simulator/",
                            iconClass: "fas fa-external-link-alt"
                        }
                    ]
                },
                {
                    label: "Holistic DNA Analyzer",
                    path: "https://github.com/stefanocaronia/holistic-dna-analyzer",
                    desc: "A Python/agent framework that can read your DNA data and answer your questions about it.",
                    iconClass: "fas fa-cubes",
                    status: "Completed"
                },
                {
                    label: "Withings MCP",
                    path: "https://github.com/stefanocaronia/withings-mcp",
                    desc: "A local MCP server that lets an AI assistant read your own Withings health data: body measurements, blood pressure, sleep summaries, daily activity and paired devices. Written in Python, it talks directly to the official Withings API with credentials kept on your machine, with no third-party services in between.",
                    iconClass: "fas fa-cubes",
                    status: "Completed"
                },
                {
                    label: "L'idolo dei tombini",
                    path: "#section-adventure",
                    desc: "Short text adventure integrated into this site. The story was created by AI, while the game system was designed and coded by me.",
                    iconClass: "fas fa-cubes",
					status: "Completed"
                },
                {
                    label: "Qr2l",
                    path: "https://github.com/stefanocaronia/qr2l",
                    desc: "A minimalistic QR code generator written in C#.",
                    iconClass: "fas fa-cubes",
					status: "Completed"
                },
                {
                    label: "RDP Patch",
                    path: "https://github.com/stefanocaronia/rdppatch",
                    desc: "Patches Windows to enable multiple RDP connections.",
                    iconClass: "fas fa-cubes",
					status: "Completed"
                }
            ],
            archive: [
                {
                    label: "ShushaoEngine",
                    path: "https://github.com/stefanocaronia/ShushaoEngine",
                    desc: "2D game engine in C++.",
                    year: "2017"
                },
                {
                    label: "Solitario",
                    path: "https://github.com/stefanocaronia/solitario",
                    desc: "Solitaire card game built with Unity.",
                    year: "2017"
                },
                {
                    label: "Space Mania",
                    path: "https://github.com/stefanocaronia/space-mania",
                    desc: "Prototype for an arcade space shooter in Unity.",
                    year: "2017"
                },
                {
                    label: "Obsim",
                    path: "https://github.com/stefanocaronia/obsim",
                    desc: "C++ utility for finding unused images.",
                    year: "2017"
                },
                {
                    label: "Whop",
                    path: "https://github.com/stefanocaronia/whop",
                    desc: "C++ utility for opening files from web paths.",
                    year: "2017"
                },
                {
                    label: "Wallyti",
                    path: "https://github.com/stefanocaronia/wallyti",
                    desc: "jQuery tiled wall plugin.",
                    year: "2015"
                },
                {
                    label: "SlideAd",
                    path: "https://github.com/stefanocaronia/jquery-slidead",
                    desc: "jQuery slide ad plugin.",
                    year: "2013"
                }
            ],
        }
    },
    stack: {
        label: "Stack",
        icon: "fa-code",
        content: [
            {
                label: "Languages",
                iconClass: "fas fa-code",
                tags: ["C#", "C++", "JavaScript", "PHP", "Java", "SQL"]
            },
            {
                label: "Game Development",
                iconClass: "fas fa-gamepad",
                tags: ["Unity", "Box2D", "SDL", "OpenGL"]
            },
            {
                label: "Web",
                iconClass: "fas fa-globe",
                tags: ["Vue.js", "Angular", "jQuery", "Symfony"]
            },
            {
                label: "Tools",
                iconClass: "fas fa-wrench",
                tags: ["Git", "Plastic SCM", "JetBrains Rider", "Visual Studio Code"]
            },
            {
                label: "Music",
                iconClass: "fas fa-music",
                tags: ["Cubase", "Ableton", "Audacity", "SID Factory II"]
            },
            {
                label: "Graphics & Media",
                iconClass: "fas fa-palette",
                tags: ["Blender", "Photoshop", "Krita", "Premiere"]
            }
        ]
    },
    gaming: {
        label: "Gaming",
        icon: "fa-gamepad",
        content: [
            {
                label: "Currently Playing",
                iconClass: "fas fa-play",
                tags: [
                "Baldurs Gate 3",
                "Euro Truck Simulator",
                "Ghost of Tsushima",
                "Cairn",
                ]
            },
            {
                label: "Played and Loved",
                iconClass: "fas fa-heart",
                tags: [
                "The Witcher 3",
                "Cyberpunk 2077",
                "Doom Eternal",
                "Sifu",
                "No Man's Sky",
                "Valheim",
                "The Sims",
                "Minecraft"
                ]
            },
            {
                label: "Online worlds",
                iconClass: "fas fa-globe",
                tags: [
                "Dark Age Of Camelot",
                "Star Wars Galaxies",
                "Warhammer Online",
                "City Of Heroes",
                "Throne And Liberty",
                "New World",
                "Second Life",
                ]
            }
        ]
    },
    adventure: {
        label: "L'idolo dei tombini",
        icon: "fa-gamepad",
        content: {
            text: "A short text adventure built into the Interactive Console. For now it is available only in Italian, because both the parser and the world interactions are written around Italian verbs and phrasing.",
            points: [
                {
                    label: "How to start",
                    iconClass: "fas fa-play",
                    tags: [
                    "Open the Interactive Console",
                    "Type guarda",
                    "Then explore with commands like nord, sud, est, ovest or vai porta rossa"
                    ]
                },
                {
                    label: "Useful commands",
                    iconClass: "fas fa-terminal",
                    tags: [
                    "guarda",
                    "inventario",
                    "prendi [oggetto]",
                    "apri [oggetto]",
                    "apri [porta] con [chiave]",
                    "dai [oggetto] a [personaggio]",
                    "parla [personaggio]",
                    "saluta [personaggio]",
                    "attacca [personaggio]",
                    "save",
                    "load"
                    ]
                },
                {
                    label: "Tone and intent",
                    iconClass: "fas fa-skull",
                    tags: [
                    "Grotesque underground world",
                    "Strange people",
                    "Monsters",
                    "Dark humor",
                    "A final treasure"
                    ]
                }
            ]
        }
    },
    console: {
        label: "Terminal",
        icon: "fa-desktop",
        content: {}
    }
};
